import React from "react";
import PropTypes from "prop-types";
import config from "lib/config";
import moment from "moment";

const withLanguageContext = (ComposedComponent, languageContext) =>
  class extends React.Component {
    constructor(props) {
      super(props);
      this.state = { languageContext: "", ready: false };

      this.key = this.key.bind(this);
    }

    async componentDidMount() {
      await this.fetchContext();
    }

    async fetchContext() {
      let now = moment();
      let localStorageAvailable =
        window.localStorage && window.localStorage.getItem(languageContext);
      let savedTimestamp = localStorage.getItem(languageContext + "_timestamp");
      let savedTimestampDate = moment(
        savedTimestamp,
        "ddd MMM DD YYYY HH:mm:ss ZZ",
        "en",
      );
      let daysStored = now.diff(savedTimestampDate, "days") || 0;
      let shouldFetch =
        daysStored > 0 ||
        savedTimestamp === null ||
        config.culture !==
          window.localStorage.getItem(languageContext + "_culture");
      if (localStorageAvailable && !shouldFetch) {
        let data = localStorage.getItem(languageContext);
        this.setState({ languageContext: JSON.parse(data), ready: true });
      } else {
        let data = await fetch(
          `${config.apiUrl}v1/translation-strings/${config.culture}/${languageContext}`,
        ).then((res) => res.json());
        this.setState({ languageContext: data, ready: true });
        localStorage.setItem(languageContext, JSON.stringify(data));
        localStorage.setItem(languageContext + "_timestamp", moment());
        localStorage.setItem(languageContext + "_culture", config.culture);
      }
    }

    key(key) {
      let customKey = key + "_" + config.installationId;
      let smallCustom = customKey.toLowerCase();
      if (this.state.languageContext[smallCustom])
        return this.state.languageContext[smallCustom];

      return key
        ? this.state.languageContext[key.toLowerCase()] || `${key} *️`
        : null;
    }

    render() {
      const { ready } = this.state;

      return ready ? (
        <ComposedComponent {...this.props} languageContext={this.key} />
      ) : null;
    }
  };

withLanguageContext.propTypes = {
  languageContext: PropTypes.object.isRequired,
};

withLanguageContext.defaultProps = {
  languageContext: {},
};

export default withLanguageContext;
